import { render } from "./Splash.vue?vue&type=template&id=6fbc5806"
import script from "./Splash.vue?vue&type=script&lang=js"
export * from "./Splash.vue?vue&type=script&lang=js"

import "./Splash.vue?vue&type=style&index=0&id=6fbc5806&lang=css"

import exportComponent from "/builds/uf-manage/mobile/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__